/**
 * Índice de MIS AULAS (A4): la puerta del alumno a sus cohortes. El escalón
 * docente entra por `/academy/cohorts`; ésta es la del alumnado.
 */
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { MyClassroomsView } from "@/features/academy/components/classroom/my-classrooms-view";

export const classroomIndexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/classroom",
  component: MyClassroomsView,
});
